import React, { useEffect, useState } from 'react';
import { Modal, Button, Icon } from 'antd';
import styled from 'styled-components';
import moment from 'moment';
import { ModalContent, ModalText, ModalTextContent, ModalTextLine, ModalTextTitle } from '../agenda/DateWarningModal';
import { GetPaymentPhasePriceByYear } from '../../infra/requests/MyWeddingRequests';

let AlreadyReservedModal = ({
  openModal,
  closeModal,
  onSubmit,
  loading,
  initialValues,
  weddingDate,
  translate,
  activeLanguage
}) => {
  const [firstPhasePrice, setFirstPhasePrice] = useState(null);

  useEffect(() => {
    const getFirstPhasePrice = async () => {
      if (!openModal || !weddingDate) return setFirstPhasePrice(null);

      const year = moment.utc(weddingDate).year();
      const result = await GetPaymentPhasePriceByYear(year);
      setFirstPhasePrice(result?.success ? result?.data?.firstPhasePrice : null);
    };

    getFirstPhasePrice();
  }, [openModal, weddingDate]);

  const modalTitle = () => {
    switch (activeLanguage?.code) {
      case 'pt':
        return 'Casal reincidente';
      case 'en':
        return 'Repeat offender couple';
      case 'es':
        return 'Pareja reincidente';
      case 'fr':
        return 'Couple de récidivistes';
    }
  }

  const modalText = () => {
    const priceAmount = firstPhasePrice != null ? `${firstPhasePrice}€` : '';

    switch (activeLanguage?.code) {
      case 'pt':
        return `
          Dado que já tinham confirmado o casamento anteriormente, mas não efetuaram o pagamento dentro do prazo estipulado após a receção do contrato, a plataforma classificou o vosso registo (casamento) como incumpridor.</br></br>

          Por esse motivo, não é possível validar uma nova confirmação sem o pagamento do sinal${priceAmount ? ` no valor de ${priceAmount}` : ''}.</br></br>

          Assim, deverão efetuar o pagamento e carregar o comprovativo no momento da confirmação.</br>
          Procederemos à emissão do novo contrato para assinatura, assim que possivel.</br></br>

          Até essa validação, o casamento permanecerá com o estado de confirmação pendente.</br></br>

          Com os melhores cumprimentos,</br>
          Carina Macedo
        `;
      case 'en':
        return `
          Since you had already confirmed the wedding previously but did not complete the payment within the deadline stipulated after receiving the contract, the platform has classified your registration (wedding) as non-compliant.</br></br>

          For this reason, it is not possible to validate a new confirmation without the payment of the deposit${priceAmount ? ` in the amount of ${priceAmount}` : ''}.</br></br>

          Therefore, you must make the payment and upload the proof of transfer at the time of confirmation.</br>
          We will issue a new contract for signature as soon as possible.</br></br>

          Until this validation is complete, the wedding will remain in a pending confirmation status.</br></br>

          Kind regards,</br>
          Carina Macedo
          `;
      case 'es':
        return `
              Dado que usted ya había confirmado la boda previamente, pero no realizó el pago dentro del plazo estipulado tras recibir el contrato, la plataforma ha clasificado su registro (boda) como no conforme.</br></br>

              Por este motivo, no es posible validar una nueva confirmación sin el pago del depósito${priceAmount ? ` por un importe de ${priceAmount}` : ''}.</br></br>

              En consecuencia, debe realizar el pago y adjuntar el comprobante de transferencia al momento de la confirmación.</br>
              Le enviaremos un nuevo contrato para su firma lo antes posible.</br></br>

              Hasta que se complete esta validación, la boda permanecerá en estado de confirmación pendiente.</br></br>

              Atentamente,</br>
              Carina Macedo
            `;
      case 'fr':
        return `
                Comme vous aviez déjà confirmé le mariage mais n'avez pas effectué le paiement dans le délai imparti après réception du contrat, la plateforme a considéré votre inscription comme non conforme.</br></br>

                De ce fait, il est impossible de valider une nouvelle confirmation sans le versement de l'acompte${priceAmount ? ` d'un montant de ${priceAmount}` : ''}.</br></br>

                Vous devez donc procéder au paiement et fournir la preuve de virement lors de la confirmation.</br>
                Nous vous ferons parvenir un nouveau contrat à signer dans les plus brefs délais.</br></br>

                En attendant cette validation, le mariage restera en attente de confirmation.</br></br>

                Cordialement,</br>
                Carina Macedo
              `;
    }
  }

  return (
    <Modal
      visible={openModal}
      title={modalTitle()}
      maskClosable
      onCancel={closeModal}
      footer={[
        <Button
          key='cancel'
          onClick={() => closeModal()}>
          {translate('CANCEL')}
        </Button>,
        <Button
          key='submit'
          loading={loading}
          type='primary'
          onClick={() => onSubmit()}>
          {translate('CONFIRM')}
        </Button>
      ]}
    >
      <div dangerouslySetInnerHTML={{ __html: modalText() }} />
    </Modal>
  );
};

export default AlreadyReservedModal;